export const lensCtaStrings = {
    label: "Call-to-Action",
    // TODO check learn more url value
    tooltipContent: "Call-to-Action allows you to direct Snapchatters to your website or app.",
    description: "Add a link that users can interact with while using your lens.",
    formStrings: {
        type: {
            label: "Call-to-Action Type",
            tooltipContent: "Select the Call-to-Action type for users to engage with.",
        },
        url: {
            placeholder: "https://www.website.com",
            label: "Website URL",
            tooltipContent:
                'Where Snapchatters will be taken when they click on the Call-to-Action. \
                    Please include the network location (e.g., "http://" or "https://") in the URL.',
        },
        uri: {
            label: "Deep Link URI",
            tooltipContent: "Where Snapchatters will be taken when they click on the Call-to-Action.",
            placeholder: "yourapp://yourlink",
        },
        appName: {
            label: "App Name",
            tooltipContent: "Name of your App",
            placeholder: "Your App Name, e.g. Snapchat",
        },
        iosAppId: {
            label: "iOS App ID",
            tooltipContent:
                "This is a required field. The Apple Store ID should be numeric value only \
                    (e.g., Snapchat's Apple Store ID is “447188370”). If user does not have app installed, \
                    the user will fallback to the Apple Store to download the app.",
            placeholder: "12345678",
        },
        androidAppUrl: {
            label: "Android App URL",
            placeholder: "com.myapp.android",
            tooltipContent:
                "This is a required field. The Google Play Store ID can be found after “id=” in store \
                URL (e.g., Snapchat's Google Play Store ID is “com.snapchat.android”. If user does not have app \
                installed, the user will fallback to the Google Play Store to download the app.",
        },
        text: {
            label: "Call-to-Action Text",
            tooltipContent: "Select the text for your Call-to-Action, which will appear over the Camera button.",
        },
    },
};
